import { Box } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { SyncBadge } from "../../common/badges";
import BrightnessBar from "../common/brightness-bar";

const Brightness1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [brightness, setBrightness] = useState(0);
  const [w1, setW1] = useState({});
  const [minMax, setMinMax] = useState({ min: 0, max: 100 });
  const sliderRef = React.useRef(null);
  const lastValueRef = useRef(null);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const initialValue = Number(widget.items.$w1.value);
      setMinMax({
        min: widget.items.$w1.min ?? 0,
        max: widget.items.$w1.max ?? 100,
      });
      setBrightness(initialValue);
      lastValueRef.current = initialValue;
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    if (data === lastValueRef.current) return;
    console.log("data", data);
    const updatedWidget = {
      ...widget.items.$w1,
      value: data,
    };
    lastValueRef.current = data;
    onValueUpdate(updatedWidget);
  };

  const handleBrightnessChange = (event, newValue) => {
    event.stopPropagation();
    const adjustedValue = Math.min(Math.max(newValue, minMax.min), minMax.max);
    setBrightness(adjustedValue);
  };

  return (
    <Box sx={{ height: "100%", width: "100%", position: "relative" }}>
      {pattern && pattern.endsWith("_W") && <SyncBadge />}
      {w1 && (
        <BrightnessBar
          value={brightness}
          onChange={handleBrightnessChange}
          disabled={pattern && pattern.endsWith("_R")}
          onValueUpdate={handleValueUpdate}
          min={minMax.min}
          max={minMax.max}
          sliderRef={sliderRef}
        />
      )}
    </Box>
  );
};

export default Brightness1Widget;
